import styled from 'styled-components';

import { ThemeProp } from '../../theme/Themes';

export const SegmentedButtonContainer = styled.div`
  display: flex;
  overflow: hidden;
  margin-bottom: 1rem;
`;

interface SegmentedButtonItemProps {
  $selected?: boolean;
  $disabled?: boolean;
}
export const SegmentedButtonItem = styled.div<SegmentedButtonItemProps>`
  flex: 1;
  padding: 0.625rem;
  text-align: center;
  cursor: ${({ $disabled }: SegmentedButtonItemProps) => ($disabled ? 'not-allowed' : 'pointer')};
  background: ${({ theme, $selected, $disabled }: SegmentedButtonItemProps & ThemeProp) =>
    $selected ? ($disabled ? theme.colors.neutrals.c100 : theme.gradients.primary) : 'none'};
  color: ${({ theme, $selected, $disabled }: SegmentedButtonItemProps & ThemeProp) =>
    $selected ? ($disabled ? theme.colors.primary.c300 : theme.colors.content.white) : theme.colors.content.default};

  border-style: solid;
  border-color: ${({ theme }: ThemeProp) => theme.colors.neutrals.c200};
  border-width: 0.0625rem;

  border-left-width: 0;

  &:first-child {
    border-left-width: 0.0625rem;
    border-radius: 0.5rem 0 0 0.5rem;
  }

  &:last-child {
    border-right-width: 0.0625rem;
    border-radius: 0 0.5rem 0.5rem 0;
  }

  font-size: ${({ theme }: ThemeProp) => theme.fontSize.s};
  line-height: ${({ theme }: ThemeProp) => theme.fontVariants.desktop.body2.lineHeight};
  font-weight: ${({ theme }: ThemeProp) => theme.fontWeight.regular};
`;
